import { creditCardDetailsEntryStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CreditCardDetailsEntry";
import { FormFieldStyle, FormInputWrapper } from "@insite/mobius/FormField";
import { InputStyle } from "@insite/mobius/TextField";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

creditCardDetailsEntryStyles.cardHolderNameGridItem = {
    width: 12,
    css: css`
    >${FormFieldStyle}{
        >${FormInputWrapper}{
            > ${InputStyle} {
                :focus {
                    border: 2px solid ${getColor("primary")} !important;
                }
            }
        }
    }
    `
}

creditCardDetailsEntryStyles.cardNumberGridItem = {
    width: 12,
        css: css`
        >${FormFieldStyle}{
            >${FormInputWrapper}{
                > div[class^="TokenExFrameWrapper"] {
                    :focus {
                        border: 2px solid ${getColor("primary")} !important;
                    }
                }
            }
        }
        `
}

creditCardDetailsEntryStyles.securityCodeGridItem = {
    width: 12, 
        css: css`
        >${FormFieldStyle}{
            >${FormInputWrapper}{
                > div[class^="TokenExFrameWrapper"] {
                    :focus {
                        border: 2px solid ${getColor("primary")} !important;
                    }
                }
                >div[class^="DescriptionWrapper"]{
                    >${TypographyStyle}{
                        font-size: 16px;
                        color: ${getColor("secondary")};
                    }
                }
            }
        }
    `
}